import React from 'react'

export const ValidIndicator = () => {
  return <span>Valid</span>
}
export const InvalidIndicator = () => {
  return <span>Invalid</span>
}
